import { ThemeMapQueryNew } from 'common-types'
import ThemeMapGrades from 'components/core-adoption/builder/ThemeMapGrades'
import calculateScrollHeight from 'components/core-adoption/functions/calculateScrollHeight'
import SectionTitle from 'components/global/SectionTitle'
import { Col, Row, Section } from 'components/grid'
import { H2 } from 'components/typography/Headings'
import { P } from 'components/typography/Paragraph'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import { graphql, useStaticQuery } from 'gatsby'
import React, { useContext } from 'react'

const ThemeMapEnglish = () => {
	const { account, language, standard } = useContext(CoreAdoptionContext)
	const ccssData = useStaticQuery<ThemeMapQueryNew>(query).ccss
	const teksData = useStaticQuery<ThemeMapQueryNew>(query).teks
	const data = standard === 'teks' ? teksData : ccssData

	return (
		<Section margin="mt-14" id="recommended-unit-plan-english" scrollMarginTop={calculateScrollHeight()}>
			<Row center>
				<Col>
					<div className="mx-auto mb-10 max-w-3xl text-center">
						<H2 className="text-balance mb-1">{language === 'english' ? 'ARC Core' : 'ARC Core'}</H2>
						<span className="mb-2 block text-lg font-semibold italic">
							{language === 'english' ? 'Designed for 75-120 minute literacy blocks' : 'Diseñado para bloques de alfabetización de 75 a 120 minutos'}
						</span>
						<P>
							{language === 'english'
								? 'ARC Core includes four units per grade per year. Click on any theme below to review included materials. For more information, contact your ARC account manager.'
								: 'ARC Core en español incluye cuatro unidades por grado por año. Haga clic en un tema en el mapa temático siguiente recomendado para español para ver los materiales incluidos en esa Unidad.'}
						</P>
					</div>
				</Col>
			</Row>

			<Row>
				<Col>
					<p className="mx-auto mb-10 max-w-3xl text-center text-ar-100">
						{language === 'english' && standard === 'teks' ? 'Please note that frameworks under review will be updated when available.' : ''}
					</p>
					<p className="mx-auto mb-10 max-w-3xl text-center text-ar-100">
						{language === 'spanish' && standard === 'teks'
							? 'Nota: Tenga en cuenta que los Manuales de instrucción son actualizados cuando nuevas ediciones están disponibles.'
							: ''}
					</p>
					<ThemeMapGrades data={data} language="english" grades={account ? account.english_grades : []} />
				</Col>
			</Row>
		</Section>
	)
}

const query = graphql`
	query {
		ccss: contentfulThemeMap(name: { eq: "Default (2021)" }) {
			...coreAdoptionThemeMap
		}
		teks: contentfulThemeMap(name: { eq: "Default TEKS" }) {
			...coreAdoptionThemeMap
		}
	}
`

export default ThemeMapEnglish
